module.exports = __webpack_public_path__ + "img/gif-chrome.7e8bc68e.gif";